import { motion } from "framer-motion";

export function PageHero({ eyebrow, title, subtitle, image, testId, children }) {
  return (
    <section
      data-testid={testId || "page-hero"}
      className="relative isolate overflow-hidden pt-32 pb-20 md:pt-40 md:pb-28 bg-npbc-black text-white"
    >
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 h-full w-full object-cover opacity-40"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-npbc-black/70 via-npbc-black/60 to-npbc-black" />
        </>
      )}
      <div className="container-npbc relative">
        {eyebrow && <div className="eyebrow !text-npbc-gold">{eyebrow}</div>}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-3 heading-serif text-5xl sm:text-6xl md:text-7xl leading-[0.98] text-balance"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="mt-5 max-w-2xl text-white/75 text-lg leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-white/[0.02]" />
    </section>
  );
}

export function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      <h2 className="mt-3 heading-serif text-4xl sm:text-5xl leading-[1.05] text-npbc-black">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-npbc-gray/85 text-[17px] leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}
